export default __webpack_public_path__ + "static/media/student-online-application-bg-frame.9f053a48.png";